var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-condition-values-autocomplete"},[_c('MultiselectInput',{attrs:{"items":_vm.flatItems,"loading":_vm.isLoading,"value":_vm.value,"placeholder":"Search More","search":_vm.search,"searchable":true,"emit-object":true},on:{"input":_vm.edit,"update:search":_vm.setSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }